export default __webpack_public_path__ + "449b1859c09bcb25d5dab7748b90f6b3.png";